
// src/i18n/message-ja.js

import moment from 'moment'
import 'moment/locale/ja'

export default {
  initialize: ()=> {
    moment.locale('ja')
    moment.updateLocale('ja', {
      longDateFormat: {
        LLLL: "YYYY年M月D日(ddd)",
        llll: "M月D日(ddd)",
        ll:"YYYY年M月",
        l: "HH:mm"
      },
    })
  },
  message: {
    "ようこそ": "gamba! にようこそ！",
    "ログインしてください": "ログインしてください。",
    "メンテナンス中": "ただいま、メンテナンス中です。\n\ngamba!は機能改善に向けて日夜作業を続けています。\n\nもう少しで、さらに機能アップしたgamba!をご利用いただけるようになります。\nいましばらく、おまちください。\n弊社からのメンテナンスのお知らせは下記をご覧ください。",
  },
  diary: {
    memo: 'ノート',
    diary: '日報',
    kpi: 'KPI',
    "diaryを書く": "日報を投稿する\n(テンプレートを選択する)",
    "kpiを書く": "KPI進捗を投稿する\n(テンプレートを選択する)",
    "memoを書く": "ノートを投稿する\n(テンプレートを選択する)",
    "diaryを投稿" : "日報を投稿しました。お疲れ様でした！",
    "kpiを投稿" : "KPIを投稿しました。お疲れ様でした！",
    "memoを投稿" : "ノートを投稿しました。",
  },
  format: {
    diary_subject: "{{ reported_at, date}}の{{ category }}",
    timestamp: "{{ timestamp, fromNow }}",
    savedAt: "{{ timestamp, fromNow }}に保存",
    month: "YYYY年M月",
  },
  calendar: {
    monthNames: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
    monthNamesShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
    dayNames: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日',
    dayNamesShort: '日_月_火_水_木_金_土',
  },
  label: {
    "gamba": "日報アプリgamba!",
    "株式会社gamba": "株式会社gamba",
    "無料": "無料",
    "ピックアップ": "ピックアップ",
    "アプリ名": "gamba!",
    "お問い合わせ": "その他お問い合わせはこちら",
    "ヘルプページを開く": "ヘルプページを開く",
    "入門ガイドを開く":"入門ガイドを開く",
    "問い合わせる": "サポートに問い合わせ",
    "アプリもあります": "便利なスマートフォンアプリはいますぐ！こちらから",
    "お知らせがあります": "お知らせがあります",
    "更新が必要です": "更新が必要です",
    "更新する": "更新する",
    "gambaで開く": "gamba!で開く",
    "サービスが更新されています": "サービスが更新されています。いますぐ、再読み込みを行なってください。",
    "お知らせを開く": "お知らせを開く",
    "新着のお知らせ": "gamba!の新着のお知らせ",
    "新着のメッセージ": "{{ name }}さんからのメッセージ",
    "添付ファイルが届いています": "添付ファイルが届いています。",
    "メールアドレスを確認してください": "メールアドレスを確認ください",
    "メールアドレスの確認が完了していません": "メールアドレスの確認が完了していません",
    "メールアドレスの確認を行ってください": "お客様のメールアドレス宛に「gamba! 登録のお知らせ」メールを送信しております。こちらのメールを開き、メールアドレスの確認を完了してください。もしメールが見当たらない場合は、以下より再送を行なってください。",
    "確認メール再送": "確認メール再送",
    "サービスは現在ご利用いただけません": "サービスは現在ご利用いただけません。",
    "お知らせページを開く": "お知らせページを開く",
    "メニュー": "メニュー",
    "検索結果": "検索結果",
    "新着の通知": "新着の通知",
    "カレンダー": "カレンダー",
    "カレンダー連携": "カレンダー連携",
    "カレンダーを解除": "カレンダーを解除",
    "Googleカレンダー": "Googleカレンダー",
    "Googleカレンダーに接続": "Googleカレンダーに接続",
    "Googleドライブに接続する": "GOOGLEドライブに接続する",
    "Googleカレンダーを解除": "Googleカレンダーを解除",
    "Googleドライブに連携する": "GOOGLEドライブに連携する",
    "Googleドライブを解除": "Googleドライブを解除",
    "日報のエクスポートは最大1年分": "日報のエクスポートは最大1年分をエクスポート可能です。再度、操作を行なってください。",
    "Outlookカレンダー": "Outlookカレンダー (Beta版)",
    "Outlookカレンダーに接続": "Outlookカレンダーに接続 (Beta版)",
    "Outlookカレンダーを解除": "Outlookカレンダーを解除",
    "説明を表示": "説明を表示",
    "時間を表示": "時間を表示",
    "貼付ヒント": "チェックを入れて「貼付け」を押すとその日程の「説明」が追加されます。",
    "カレンダーの予定を貼り付けました": "カレンダーの予定を貼り付けました",
    "予定がありません": "予定がありません。",
    "メンバーリスト" : "メンバーリスト",
    "メンバーとミッション": "メンバーとミッション",
    "ミッションが設定されていません": "ミッションが設定されていません。",
    "グループのメンバー": "{{ name }}のメンバー",
    "メンバー": "メンバー",
    "メンバーを追加" : "メンバーを追加",
    "設定" : "設定",
    "日報提出状況": "日報提出状況",
    "インサイト": "インサイト",
    "アルバム" : "アルバム",
    "データがありません" : "データがありません",
    "詳細をすべて表示": "詳細をすべて表示",
    "KPI進捗状況": "KPI進捗状況",
    "KPIの進捗状況": "{{ name }}の進捗状況",
    "添付ファイル": "添付ファイル",
    "画像" : "画像",
    "動画・音声" : "動画・音声",
    "ファイル" : "ファイル",
    "アルバム" : "アルバム",
    "ログイン": "ログイン",
    "確認コード": "確認コード",
    "確認コードについて": "本人確認のため、数字6桁の確認コードをメールで送信しましたので、確認してください。",
    "次へ": "次へ",
    "いますぐログイン": "いますぐログイン！",
    "うまくログインできない時": "ログインできない? こちらをご覧ください",
    "無料体験に登録": "初めての利用ですか? 無料登録はこちら",
    "無料体験の登録方法": "無料体験への登録方法はこちら",
    "このアプリについて": "このアプリについて",
    "アプリの説明": "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}\nモデル: {{model}}",
    "アプリの説明 モデル無し": "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}",
    "アプリの説明(staging)": "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}\nモデル: {{model}}\nStaging環境です。",
    "アプリの説明 モデル無し(staging)": "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}\nStaging環境です。",
    "メールアドレスを選択": "メールアドレスを選択",
    "パスワードの変更が必要です": "パスワードの変更が必要です。",
    "パスワードを変更してログイン": "パスワードを変更してログイン",
    "シングルサインオン認証を行ってください": "シングルサインオン認証を行ってください。",
    "メールアドレス": "メールアドレス",
    "パスワード": "パスワード",
    "個人設定": "個人設定",
    "グループ設定": "グループ設定",
    "グループ新規作成": "グループ新規作成",
    "プロフィール設定": "プロフィール設定",
    "お気に入り登録": "フォロー設定",
    "フォロー": "フォロー",
    "フォロー中": "フォロー中",
    "お気に入りに追加": "フォローする",
    "お気に入りから削除": "フォローを外す",
    "ブロック": "ブロック",
    "ブロックリスト": "ブロックリスト",
    "ブロック解除": "ブロック解除",
    "ユーザのブロック": "このユーザをブロックをします。",
    "ブロックユーザの解除": "このユーザのブロックを解除します。",
    "ユーザのブロック説明": "ブロックした場合、あなたの「すべての投稿」や「グループのタイムライン」からこのユーザの投稿が表示されなくなります。ブロック解除はブロックしたユーザのタイムラインか 「個人設定」 > 「ブロックリスト」から解除できます。",
    "ブロックユーザの解除説明": "ブロック解除した場合、あなたの「すべての投稿」や「グループのタイムライン」にこのユーザの投稿が表示されるようになります。",
    "投稿のブロック": "この投稿をブロックします。",
    "投稿のブロック解除": "この投稿のブロックを解除します。",
    "投稿のブロック説明": "ブロックした場合、あなたの「すべての投稿」やグループのタイムラインからこの投稿が表示されなくなります。ブロック解除はブロックしたユーザのタイムラインから解除できます。",
    "投稿のブロック解除説明": "ブロック解除した場合、あなたの「すべての投稿」やグループのタイムラインに表示されるようになります。",
    "投稿ブロックされています": "この投稿はブロックされています。",
    "ユーザブロックされています": "このユーザはブロックされています。",
    "パスワード変更": "パスワード変更",
    "パスワード再発行": "パスワードがわからない? 再発行はこちら",
    "gambaについて": "gamba!について知りたい? 詳しくはこちら",
    "通知設定": "通知設定",
    "自分用テンプレート": "自分用テンプレート",
    "共通テンプレート": "共通テンプレート",
    "アカウント管理": "アカウント管理",
    "アカウント管理画面を開く": "アカウント管理画面を開く",
    "ログアウト": "ログアウト",
    "ログアウトします": "ログアウトします",
    "基本設定": "基本設定",
    "メンバー管理": "メンバー管理",
    "KPI設定": "KPI設定",
    "ごみ箱に移動": "ごみ箱に移動",
    "ダウンロード": "ダウンロード",
    "チャット": "チャット",
    "チャットをする": "チャットをする",
    "ご自身のユーザーでチャットを行うことはできません": "ご自身のユーザーでチャットを行うことはできません",
    "対象ユーザーはこのチャットルームには参加していません。" : "対象ユーザーはこのチャットルームには参加していません。",
    "日報提出状況": "日報提出状況",
    "未読の投稿": "未読の投稿",
    "未読の投稿があります": "{{ unreadCount }}件の未読の投稿があります。",
    "未読の投稿がたくさんあります": "10件以上の未読の投稿があります。",
    "件": "件",
    "件以上": "件以上",
    "すべて開封にする": "すべて開封",
    "未読の投稿を開く": "未読の投稿を開く",
    "目標": "目標",
    "実績": "実績",
    "合計実績": "合計実績",
    "累計": "累計",
    "達成率": "達成率",
    "合計達成率": "合計達成率",
    "達成ライン": "100%達成ライン",
    "合計": "合計",
    "達成": "達成 !",
    "返信": "返信",
    "内容": "内容",
    "添付": "添付",
    "了解": "了解",
    "完了": "完了",
    "送信": "送信",
    "登録": "登録",
    "更新": "更新",
    "提出": "提出",
    "新規作成": "新規作成",
    "編集": "編集",
    "概要": "概要",
    "詳細": "詳細",
    "戻る": "戻る",
    "操作": "操作",
    "gambaアプリで開く": "このページをgamba!アプリで開く",
    "アプリで開く": "アプリで開く",
    "アプリをダウンロード": "アプリをダウンロード",
    "アプリを使用しない": "gamba!アプリを使用しない",
    "クリックして値を更新": "クリックして値を更新",
    "アイコン画像":"アイコン画像",
    "自分のミッション":"自分のミッション",
    "グループのミッション":"グループのミッション",
    "写真動画を選択":"写真・動画を選択",
    "ドキュメントを選択":"ドキュメントを選択",
    "ファイルを選択":"ファイルを選択",
    "エクスポート": "エクスポート",
    "送信方法": "送信方法",
    "フォルダの選択":"フォルダの選択",
    "保存先":"保存先",
    "メールに送信":"メールに送信",
    "ローカルに保存":"ローカルに保存",
    "Refresh Token":"Refresh Token",
    "Refresh Tokenの取得":"Refresh Tokenの取得",
    "Googleドライブが設定されていません":"Googleドライブが設定されていません",
    "連携済み":"連携済み",
    "定期的にGoogleドライブへ自動保存する":"定期的にGoogleドライブへ自動保存する",
    "定期実行設定":"定期実行設定",
    "定期実行":"定期実行",
    "有効にする":"有効にする",
    "フォルダを選択して下さい1": "フォルダを選択して下さい",
    "フォルダを選択して下さい": "---フォルダを選択して下さい---",
    "期間設定": "期間設定",
    "日付": "日付",
    "間隔": "間隔",
    "週": "週",
    "月次": "月",
    "ユーザ": "ユーザ",
    "ユーザ名":"ユーザ名",
    "社員番号":"社員番号",
    "部署":"部署",
    "誕生日":"誕生日",
    "部署を選択":"部署を選択",
    "誕生日を追加":"誕生日を追加",
    "部署が設定されていません": "部署が設定されていません。設定が必要な場合はアカウント管理者に連絡してください。",
    "グループ名": "グループ名",
    "セクション/グループ名を検索": "セクション/グループ名を検索",
    "並べ替え": "並べ替え",
    "現在のパスワード": "現在のパスワード",
    "新しいパスワード": "新しいパスワード",
    "新しいパスワード(再入力)": "新しいパスワード(再入力)",
    "ミッションを入力してください": "ミッションを入力してください。",
    "メールアドレスを更新しました": "確認のため、新しいメールアドレス宛に確認用のメールを送信しましたので、ご確認ください。",
    "メールアドレス確認待ち": "メールアドレス {{email}} へ変更手続き中です。",
    "パスワードを更新しました": "パスワードを更新しました。",
    "プロフィールを更新しました": "プロフィールを更新しました。",
    "グループの基本設定を更新しました": "グループの基本設定を更新しました。",
    "グループを作成しました": "グループを作成しました。",
    "テンプレートを削除してもいいですか": "{{ name }}を削除してもよろしいですか?",
    "グループの公開範囲": "グループの公開範囲",
    "セクション/グループはありません": "セクション/グループはありません",
    "ユーザ追加": "ユーザを追加",
    "新規ユーザを招待": "新規ユーザを招待",
    "既存ユーザを追加": "既存ユーザを追加",
    "既存ユーザを追加します": "既に他に登録済みのユーザを追加します。",
    "メンバーは登録されていません": "メンバーは登録されていません。",
    "管理者": "管理者",
    "一般ユーザ": "一般ユーザ",
    "一般ユーザに変更": "一般ユーザに変更",
    "管理者に変更": "管理者に変更",
    "管理者に変更します": "{{ name }}をグループ管理者に変更します。",
    "一般ユーザに変更します": "{{ name }}を一般ユーザに変更します。",
    "通知する": "通知する",
    "通知しない": "通知しない",
    "リマインドを通知する": "リマインドを通知する",
    "リマインドを通知しない": "リマインドを通知しない",
    "すべてのリマインド通知を送らない": "すべてのリマインド通知を送らない",
    "リマインドの通知を停止します": "{{ name }}へのリマインド通知を停止します。",
    "リマインドの通知を開始します": "{{ name }}へのリマインド通知を開始します。",
    "ユーザを追加しました": "{{ name }}さんをこのグループのメンバーに追加しました。",
    "グループからユーザを削除しました": "{{ name }}さんをこのグループのメンバーから外しました。",
    "グループの管理権限を付与しました": "{{ name }}さんにこのグループの管理権限を付与しました。",
    "グループの管理権限を削除しました": "{{ name }}さんのグループ管理権限を削除しました。",
    "ユーザへのリマインドメールの送信を開始します": "{{ name }}さんへのリマインドメールの通知を開始しました。",
    "ユーザへのリマインドメールの送信を停止しました": "{{ name }}さんへのリマインドメールの通知を停止しました。",
    "ユーザを削除": "グループメンバーから外す",
    "ユーザを削除してもいいですか": "{{ name }}さんをメンバーから外してもよろしいですか?",
    "ユーザを削除しても過去の投稿は閲覧することができます": "グループから外しても過去の投稿は閲覧することができます。",
    "アカウント管理画面から操作": "退職などで【gamba!】から完全に削除したい場合は、アカウント管理画面からも操作が必要です。",
    "アカウント管理画面へ": "アカウント管理画面へ",
    "ユーザを選択": "ユーザを選択",
    "開始日": "開始日",
    "終了日": "終了日",
    "翌期分自動作成": "翌期分を自動で作成する",
    "Excelダウンロード": "Excel形式でダウンロード",
    "Googleアカウント": "Googleアカウント",
    "アカウント": "アカウント",
    "すべて抽出": "すべての入力項目を抽出",
    "KPIを作成": "KPIを作成",
    "現在のKPI": "現在のKPI",
    "終了したKPI": "終了したKPI",
    "PDFで保存": "PDFで保存",
    "画像で保存": "画像で保存",
    "KPIデータ設定": "KPIデータ設定",
    "データ選択": "データ選択",
    "KPIを追加": "+ KPIを追加",
    "積み上げ": "積み上げ",
    "積み上げ説明": "期間内の各KPIを積み上げグラフで表示し、累計の推移を確認できます。",
    "個人データ": "個人データ",
    "個人データ説明": "個々の社員の目標達成状況と実績をリアルタイムで追跡できます。",
    "歩留まり": "歩留まり",
    "歩留まり説明": "選択したKPI間（面談数→契約数など）の達成率を％で表示し、プロセスの効率を把握できます。",
    "歩留まりライン": "100%歩留まりライン",
    "比較": "比較",
    "比較説明": "前年同期との実績差異を表示し、成長率や改善点を確認できます。",
    "比較説明メッセージ": "選択した年の同期との実績差異1年分を表示します。",
    "使い方": "使い方",
    "並べ替え": "並べ替え",
    "並べ替えを終了": "並べ替えを終了",
    "並べ替え終了を選択": "KPIを編集する際は「並べ替えを終了する」ボタンを選択してください。",
    "ドラッグして並べ替え": "ドラッグして表示の順序の並べ替えができます。",
    "長押しして並べ替え": "長押しして表示の順序の並べ替えができます。",
    "割り当てられていません": "割り当てられていません",
    "目標値": "目標値: {{ value }}",
    "目標値2": "目標値",
    "担当者": "担当者: {{ assignments }}",
    "担当者の実績": "{{ name }}の実績",
    "KPIは登録されていません": "KPIは登録されていません。",
    "コピーして新規作成": "コピーして新規作成",
    "コピーして翌期分を作成": "コピーして翌期分を作成",
    "コピー": "(コピー)",
    "データごと削除": "データごと削除",
    "KPIを削除しました": "{{ name }}を削除しました",
    "KPIを削除してもいいですか": "{{ name }}を削除してもよろしいですか?",
    "実績値の集計方法": "実績値の集計方法",
    "プレビュー": "プレビュー",
    "プレビュー説明":"* タイムライン上で下記の表が表示されます。",
    "実績値を期間内で累計する": "実績値を期間内で累計する",
    "実績値を日毎に集計する": "実績値を日毎に集計する",
    "実績値を期間内で累計の説明": "入力した実績値を期間内で累計し、目標値に対する達成率を計算します。月間売上目標など、通常はこちらを選択します。",
    "実績値を日毎に集計の説明": "入力した実績値は累計せず、日ごとの目標値に対して達成率を計算します。日ごとの架電件数目標などは、こちらを選択します。",
    "月次グラフ": "月次グラフ",
    "日次グラフ": "日次グラフ",
    "年次": "年次",
    "月次": "月次",
    "日次": "日次",
    "集計期間": "集計期間",
    "集計日": "集計日",
    "グラフを表示": "グラフを表示",
    "KPI名": "KPI名",
    "その他のKPI": "その他のKPI",
    "KPI名の説明": "売上・利益・契約件数など",
    "期間": "期間",
    "単位": "単位",
    "単位の説明": "円・件・社など",
    "単位の表示位置": "単位の表示位置",
    "値の前に表示": "値の前に表示",
    "値の後に表示": "値の後に表示",
    "表示形式": "値の表示形式",
    "担当者と目標値の割り当て": "担当者と目標値の割り当て",
    "すべて選択": "すべて選択",
    "すべて解除": "すべて解除",
    "同じ値を設定": "同じ値を設定",
    "目標値を入力": "目標値を入力",
    "KPIを更新しました": "{{ name }}を更新しました。",
    "KPIを作成しました": "KPIを作成しました。",
    "KPIがありません": "KPIが登録されていません。",
    "開始日は終了日より前に設定してください": "開始日は終了日より前に設定してください。",
    "自動作成日は開始日より後に設定してください": "自動作成日は開始日より後に設定してください。",
    "自動作成日は終了日より前に設定してください" : "自動作成日は終了日より前に設定してください",
    "リマインド通知": "リマインド通知",
    "リマインド": "リマインド",
    "リマインド通知時刻": "リマインドの通知時刻",
    "時ごろに通知": "{{ time }}ごろに通知",
    "リマインド通知日": "リマインド通知の曜日",
    "send_on_sun": "日曜日",
    "send_on_mon": "月曜日",
    "send_on_tue": "火曜日",
    "send_on_wed": "水曜日",
    "send_on_thu": "木曜日",
    "send_on_fri": "金曜日",
    "send_on_sat": "土曜日",
    "send_on_holiday": "祝祭日",
    "個別リマインド通知": "リマインド通知の個別設定",
    "リマインド通知の送信スケジュールを変更しました": "リマインド通知の送信スケジュールを変更しました。",
    "検索キーワード": "検索キーワード",
    "検索": "検索",
    "ユーザで絞り込み": "ユーザで絞り込み",
    "すべての投稿種別": "すべての投稿種別",
    "日報のみ": "日報のみ",
    "KPIのみ": "KPIのみ",
    "ノートのみ": "ノートのみ",
    "オプション": "オプション",
    "添付ファイル付き": "添付ファイル付き",
    "いいねした投稿": "いいねした投稿",
    "すべての期間の投稿": "すべての期間の投稿",
    "日付の選択":"日付の選択",
    "投稿日": "投稿日",
    "より後の投稿": "{{ reported_at }}より後",
    "読み込み中": "読み込み中...",
    "名前で検索": "名前で検索...",
    "選択してください": "選択してください",
    "選択されていません": "選択されていません",
    "選択": "選択",
    "取り消し": "取り消し",
    "閉じる": "閉じる",
    "キャンセル": "キャンセル",
    "はい": "はい!",
    "いいえ": "いいえ",
    "OK": "OK",
    "すべてのグループ": "すべての投稿",
    "グループ": "グループ",
    "公開グループ": "公開グループ",
    "非公開グループ": "非公開グループ",
    "その他": "その他",
    "組織": "組織",
    "公開グループの説明": "アカウント内のすべてのユーザが投稿を閲覧できます。",
    "非公開グループの説明": "グループのメンバーのみが投稿を閲覧できます。",
    "グループを探す": "グループを探す",
    "隠す": "隠す",
    "すべて表示": "すべて表示",
    "表示を隠す": "表示を隠す",
    "もっと見る" : "もっと見る",
    "続きを表示": "続きを表示",
    "件のコメントをすべて表示": "以前のコメント{{ count }}件を表示",
    "が返信しました": "が返信しました・返信{{ count }}件",
    "が返信しました(1件)": "が返信しました",
    "コメントを隠す": "コメントを隠す",
    "返信を隠す": "返信を隠す",
    "テンプレートを選択": "テンプレートを選択",
    "テンプレート":"テンプレート",
    "テンプレートを編集" : "テンプレートを編集",
    "user_templates_setting": "自分専用テンプレートを編集",
    "group_templates_setting": "グループ共通テンプレートを編集",
    "下書き": "下書き ({{ count }})",
    "下書きを選択": "下書きを選択",
    "全て削除": "すべて削除",
    "入力フィールド": "かんたん入力項目",
    "form-dropdown": "メニューから選択",
    "form-text": "テキスト記述(複数行)",
    "form-string": "テキスト記述(1行)",
    "form-numeric": "数値入力",
    "form-date": "日付入力",
    "form-time": "時刻入力",
    "フィールドを追加": "入力項目を追加",
    "値": "項目の値",
    "必須": "必須入力",
    "フィールド種別": "入力種別",
    "フィールド名": "入力項目名",
    "値を入力してください": "値を入力してください",
    "未入力": "未入力",
    "新しいフィールド": "新しい入力項目",
    "フィールドの選択肢": "メニューの選択肢",
    "ドロップダウン入力の場合の選択肢を改行で区切って列挙します": "メニューの選択肢を1行ごとに列挙します。",
    "初期値を指定します": "初期値を指定します",
    "初期値": "初期値: {{value}}",
    "絵文字を入力": "絵文字を入力",
    "終日": "終日",
    "投稿種別を選択": "投稿種別を選択",
    "日報にコピー": "貼付け",
    "投稿作成":"投稿作成",
    "投稿を編集": "投稿を編集",
    "投稿を報告": "投稿を報告",
    "投稿を削除": "投稿を削除",
    "投稿を印刷": "投稿を印刷",
    "投稿を翻訳": "投稿を翻訳",
    "ピン留めされた投稿": "ピン留めされた投稿", // ピン留めされた投稿
    "ピン留め": "ピン留め", // ピン留め
    "ピン留め解除": "ピン留め解除", // ピン留め解除
    "ピン留め説明": "グループタイムラインの一番上に投稿がピン留めされます。ピン留めしますか？", // ピン留め
    "ピン留め解除説明": "ピン留め解除を解除しますか？", // ピン留め解除
    "元の表示に戻す": "元の表示に戻す",
    "翻訳": "(翻訳)",
    "リンクをコピー": "リンクをコピー",
    "本文をコピー": "本文をコピー",
    "ユーザブロック": "ユーザをブロック",
    "ユーザブロック解除": "ブロック解除",
    "投稿ブロック": "投稿をブロック",
    "投稿ブロック解除": "ブロックを解除",
    "クリップボードにコピー": "クリップボードにコピー",
    "宛先を追加": "宛先を追加",
    "編集済み": "(編集済み)",
    "編集時刻": "({{ updated }}に編集)",
    "他n人": "他{{n}}人",
    "n" : "{{ n }}",
    "n人": "{{n}}人",
    "複数n人": "{{n}}人",
    "がいいね": "がいいね！",
    "が開封": "が開封",
    "開封n": "開封 {{ n }}",
    "開封n < 3": "開封 ",
    "が読んでみて": "から読んでみて！",
    "に読んでみて": "に読んでみて！",
    "返信要求付き": "(要返信)",
    "がコメント": "がコメント",
    "n件": "{{ n }}件",
    "クリックしてもっと見る": "添付写真をもっと見る...",
    "他n個の添付写真を開く": "他{{ n }}個の添付写真をすべて見る...",
    "開封": "開封",
    "投稿": "投稿",
    "リアクション": "リアクション",
    "投稿数": "投稿数",
    "リアクション数": "リアクション数",
    "1人平均": "1人平均",
    "投稿あたり": "投稿あたり",
    "平均投稿数": "平均投稿数",
    "平均リアクション数": "平均リアクション数",
    "いいね": "いいね！",
    "ピン": "ピン",
    "got_it": "了解！",
    "good_job": "おつかれさま！",
    "thanks": "ありがとう！",
    "good_luck": "がんばれ！",
    "regards": "よろしく！",
    "excellent": "すばらしい！",
    "disappointed": "ざんねん！",
    "いいねを取り消す": "取り消す",
    "いいねといっている人はまだいません": "いいねといっている人はまだいません。",
    "読んでみてといっている人はまだいません": "読んでみてといっている人はまだいません。",
    "開封した人はまだいません": "開封した人はまだいません。",
    "コメントした人はまだいません": "コメントした人はまだいません",
    "返信した人はまだいません": "返信した人はまだいません。",
    "時間前に開封": "{{ timestamp }}に開封",
    "時間前にいいね": "{{ timestamp }}にいいね！",
    "時間前にリアクション": "{{ timestamp }}に{{ n }}",
    "時間前に送信": "{{ timestamp }}に送信",
    "時間前に返信": "{{ timestamp }}に返信済み",
    "時間前にコメント": "{{ timestamp }}にコメント",
    "時間前に返信(tab)": "{{ timestamp }}に返信済み",
    "ユーザのコメント": "{{ name }}のコメント",
    "コメント": "コメント",
    "コメントを削除": "コメントを削除",
    "コメントを編集": "コメントを編集",
    "スタンプ": "スタンプ",
    "スタンプ追加": "スタンプ追加",
    "を削除します":"を削除します",
    "読んでみて": "読んでみて！",
    "読んでみての宛先を追加": "読んでみて！ の宛先を追加",
    "返信を要求": "返信を要求する",
    "保存された投稿を削除してもいいですか": "一時保存されている投稿を削除してもよろしいですか?",
    "保存された全ての投稿を削除してもいいですか": "一時保存されている全ての投稿を削除してもよろしいですか?",
    "この投稿は削除されました" : "この投稿は削除されました",
    "日報を削除してもいいですか": "この投稿を削除してもよろしいですか?",
    "コメントを削除してもいいですか": "このコメントを削除してもよろしいですか?",
    "この操作は取り消せません": "この操作は元に戻せません。ご注意ください。",
    "この投稿を通報してもよろしいですか": "この投稿を通報してもよろしいですか?",
    "このコメントを通報してもよろしいですか": "このコメントを通報してもよろしいですか?",
    "このユーザを通報してもよろしいですか": "このユーザを通報してもよろしいですか?",
    "コメントを入力してください": "コメントを入力してください。",
    "投稿がありません": "投稿がありません。",
    "フォルダがありません": "フォルダがありません。",
    "一番最後の投稿です": "これより以前の投稿はありません。",
    "よろしいですか？":"よろしいですか？",
    "テンプレート名":"テンプレート名",
    "テンプレートをインポート": "テンプレートをインポート",
    "テンプレートを上書きしていいですか": "現在編集中の内容を選択したテンプレートで上書きしてもよろしいですか?",
    "テンプレートを作成しましょう": "テンプレートを作成しましょう。",
    "テンプレートを作成しました": "テンプレートを作成しました。",
    "テンプレートを更新しました": "{{ name }}を更新しました。",
    "テンプレートを削除しました": "{{ name }}を削除しました。",
    "テンプレートは登録されていません": "テンプレートは登録されていません。",
    "お気に入りグループに追加しました": "{{ name }}をフォローしました。",
    "お気に入りグループから削除しました": "{{ name }}のフォローを外しました。",
    "お気に入りユーザに追加しました": "{{ name }}をフォローしました。",
    "新着メッセージがあります": "{{name}}さんから新着メッセージがあります。",
    "お気に入りユーザから削除しました": "{{ name }}のフォローを外しました。",
    "投稿をブロックしました": "{{ name }}の投稿をブロックしました。",
    "投稿をブロック解除しました": "{{ name }}の投稿をブロック解除しました。",
    "ユーザをブロックしました": "{{ name }}をブロックしました。",
    "ユーザをブロック解除しました": "{{ name }}をブロック解除しました。",
    "ブロックされたユーザはありません": "ブロックされたユーザはいません。",
    "ブロックされたユーザ": "ブロックされたユーザ",
    "お気に入り登録されたユーザはありません": "フォローしているユーザはいません。",
    "お気に入り登録されたグループはありません": "フォローしているグループはありません。",
    "すでにフォロー設定済みです": "すでにフォロー設定済みです。",
    "自身のフォローはできません": "自身のフォローはできません。",
    "投稿があった時": "日報やKPI・ノートの投稿があった時",
    "コメントがあった時": "自分の投稿にコメントがあった時",
    "いいねがあった時": "自分の投稿にいいね！があった時",
    "投稿があった時app": "投稿",
    "コメントがあった時app": "自分の投稿へのコメント",
    "いいねがあった時app": "自分の投稿へのいいね",
    "返信があった時": "自分のコメントに返信があった時",
    "読んでみてがあった時": "読んでみて！が自分に送られた時",
    "読んでみてが開封された時": "自分の送った読んでみて！が開封された時",
    "お気に入りに投稿があった時": "フォローしているグループ/ユーザに投稿があった時",
    "チャットを受信した時": "チャットを受信した時",
    "返信があった時app": "いいね！やコメント返信",
    "読んでみてがあった時app": "読んでみて！",
    "読んでみてが開封された時app": "読んでみて！の開封通知",
    "お気に入りに投稿があった時app": "フォロー先での投稿",
    "チャットを受信した時app": "チャット",
    "通知none": "通知しない",
    "通知mail": "メール通知",
    "通知push": "アプリ通知",
    "通知all": "すべてに通知",
    "メール": "メール",
    "アプリ": "アプリ",
    "共通設定":"共通設定",
    "通知スケジュールを設定する": "通知スケジュールを設定する",
    "通知スケジュールを設定文言": "ここで設定した時間に通知が届きます。それ以外の時間は通知が一時停止されます。",
    "時間": "時間",
    "各グループの通知設定": "グループの通知設定",
    "グループの通知設定を変更しました": "{{ name }}への通知設定を変更しました。",
    "通知設定を変更しました": "通知設定を変更しました。",
    "一括変更しました": "全グループの通知設定を一括変更しました。",
    "チャット通知設定": "チャット通知設定(トースト表示)",
    "通知を表示": "通知を表示",
    "内容を表示": "内容を表示",
    "通知": "通知",
    "gambaから": "gamba!から",
    "通知がありません": "通知がありません。",
    "一括設定": "一括設定",
    "一括設定説明": "すべてのグループのアプリ通知、メール通知設定を一括で切り替えます。",
    "昨日の日報": "前回の日報をコピー",
    "昨日の投稿内容": "前回の投稿内容をコピー",
    "検索条件": "検索条件",
    "保存された検索条件": "保存された検索条件",
    "検索条件を保存": "この条件を保存",
    "保存": "保存",
    "新しい検索条件": "新しい検索条件",
    "検索条件を削除" : "検索条件を削除",
    "検索条件を編集" : "検索条件を編集",
    "検索条件を削除してもいいですか": "{{ name }}を削除してもよろしいですか?",
    "ノートのタイトル": "タイトル (例: 議事録・商談記録・業務連絡など)",
    "検索条件を削除しました": "{{ name }}を削除しました。",
    "検索条件を保存しました": "検索条件を保存しました。",
    "チャットの履歴がありません": "チャットの履歴がありません。",
    "チャットを開始": "チャットを開始",
    "チャットの宛先を追加": "チャットの宛先を追加",
    "メンバーを追加": "メンバーを追加",
    "メンバーを削除": "{{ name }}をこのチャットから削除します。",
    "チャットルームから削除": "{{ name }}をチャットルームから削除しました。",
    "チャットルームを削除します": "この会話の履歴がすべて削除されます。",
    "チャットルームを削除していいですか":"チャットルームを削除してもよろしいですか？",
    "チャットルームを削除しました": "{{ name }}とのチャットを削除しました。",
    "グループをごみ箱に移動": "このグループがごみ箱に移動されます。",
    "グループをごみ箱に移動してもよろしいですか":"グループをごみ箱に移動してもよろしいですか？",
    "ごみ箱に移動トースト": "{{ name }}のグループをごみ箱に移動しました。",
    "この操作はグループに参加している全てのユーザーに影響します" : "この操作はグループに参加している全てのユーザーに影響します。",
    "この操作はグループに参加している全てのユーザーに影響します(復元説明付)" : "この操作はグループに参加している全てのユーザーに影響します。\nグループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。",
    "完全削除復元説明文": "グループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。",
    "このチャットは終了しました": "このチャットは終了しています。",
    "この操作はチャットルームに参加している全てのユーザーに影響します" : "この操作はチャットルームに参加している全てのユーザーに影響します。",
    "ユーザとのチャット": "{{ name }}とのチャット",
    "既読n": "既読{{ n }}",
    "メッセージを削除": "メッセージを削除します。",
    "メッセージをコピー": "メッセージをコピー",
    "メッセージを削除": "メッセージを削除",
    "メッセージを入力してください": "メッセージを入力してください。",
    "メッセージがありません": "メッセージがありません。",
    "KPIの実績値を更新しました": "{{ reported_at }}の{{ name }}の実績値を更新しました。",
    "この値は変更できない": "{{ group_name }}グループのメンバーではないので、値を変更することはできません。",
    "アップロード中": "アップロード中...",
    "クリップボードにコピーしました": "クリップボードにコピーしました。",
    "最新版に更新します": "最新版に更新する必要があります。",
    "再読み込み": "再読み込み",
    "ここをクリックして招待してみよう": "ここをクリックして、社員のみなさんをいますぐgamba!に招待しましょう。",
    "ここをクリックして日報を投稿してみよう": "「日報を投稿する」をクリックして、いますぐ日報を投稿してみましょう。",
    "名前を変更": "名前を変更",
    "チャットルーム名を変更": "{{ name }}に変更しました。",
    "チャットルーム名": "チャットルーム名",
    "カレンダーを開く": "カレンダーを開く",
    "ファイルの添付": "ファイルを添付する",
    "カメラで撮影": "カメラで撮影",
    "写真動画を選択": "写真・動画を選択",
    "削除したメンバーのみを表示": "削除したメンバーのみを表示",
    "Googleドキュメント": "Googleドキュメント",
    "Googleドキュメントに接続": "Googleドキュメントに接続",
    "退室": "退室",
    "削除": "削除",
    "ブロック": "ブロック",
    "ブロック解除": "解除",
    "上書き": "上書き",
    "外す": "外す",
    "チャットルーム設定": "チャットルーム設定",
    "退室してもいいですか": "チャットルームから退室してもよろしいですか?",
    "退室しました": "チャットルームから退室しました。",
    "別ウィンドウで表示": "別ウィンドウで表示",
    "次ページへ": "次ページへ",
    "前ページへ": "前ページへ",
    "拡大": "拡大",
    "縮小": "縮小",
    "元に戻す": "元に戻す",
    "投稿の取得に失敗しました": "投稿の取得に失敗しました。",
    "通知の取得に失敗しました": "通知の取得に失敗しました。",
    "添付ファイルの取得に失敗しました": "添付ファイルの取得に失敗しました。",
    "メンバーの取得に失敗しました": "メンバーの取得に失敗しました。",
    "データの取得に失敗しました": "データの取得に失敗しました。",
    "KPIの取得に失敗しました": "KPIの取得に失敗しました。",
    "日報提出状況の取得に失敗しました": "日報提出状況の取得に失敗しました。",
    "チャットルームの取得に失敗しました": "チャットルームの取得に失敗しました。",
    "メッセージの取得に失敗しました": "メッセージの取得に失敗しました。",
    "Googleカレンダーの取得に失敗しました":"Googleカレンダーの取得に失敗しました。",
    "Outlookカレンダーの取得に失敗しました":"Outlookカレンダーの取得に失敗しました。",
    "予定がないため貼付けできません":"予定がないため貼付けできません。",
    "メンバー入室":"{{ name }}が参加しました。",
    "メンバー退室":"{{ name }}が退室しました。",
    "フォトライブラリに保存しました": "添付画像を保存しました。",
    "LINEで招待": "LINEで招待",
    "メールで招待": "メールで招待",
    "表示しない": "今後、表示しない",
    "招待メッセージ": "「日報共有アプリgamba!」に招待します。\n以下のリンクをクリックして登録してください。(iPhone・Androidをご利用の方はChrome・Safariなどのブラウザ専用アプリを使用してください。)",
    "ウェルカムメッセージ": "無料Webコンサルティング実施中",
    "無料ウェブ説明": "貴社に合った日報テンプレートをお作りします！",
    "ウェブ説明詳細": "基本的な操作説明もOK！\nお気軽にお申込みください。",
    "ウェブ説明予約": "WEBコンサルティングを予約する\n(ブラウザを起動します。)",
    "ウェブ説明予約(WEB版)": "WEBコンサルティングを予約する",
    "メールSubject": "{{name}}さんから「日報共有アプリgamba!」への招待が届いています。",
    "投稿を見る": "投稿を見る",
    "月次提出推移": "日報提出数の月次推移",
    "日報提出状況": "日報提出状況",
    "前月": "前月",
    "翌月": "翌月",
    "月間サマリー": "{{ name }}　日報提出状況",
    "月間日報提出状況を表示": "月間の日報提出状況を見る",
    "月": "月",
    "火": "火",
    "水": "水",
    "木": "木",
    "金": "金",
    "土": "土",
    "日": "日",
    "合計": "合計",
    "年月": "{{ year }} 年 {{ month }} 月",
    "日報アイコン": "：日報",
    "KPIアイコン": "：KPI",
    "ノートアイコン": "：ノート",
    "トライアル期間が終了しました": "無料トライアル期間が終了しました。",
    "トライアルの有効期限": "トライアルの有効期限",
    "残りX日": "残り{{ dates }}日",
    "プラン変更": "プラン変更",
    "トライアル最終日です": "トライアル最終日です。",
    "gamba!をご利用いただきありがとうございました": "gamba!をご利用いただきありがとうございました。",
    "引き続き利用するには契約が必要です": "引き続きご利用いただくためには、契約のお申し込みが必要です。",
    "契約する": "いますぐ契約を申し込む",
    "タイムゾーン": "タイムゾーン",
    "言語": "言語",
    "通知アイコン":"通知",
    "日報提出状況アイコン": "提出状況",
    "KPI進歩状況アイコン": "KPI",
    "チャットアイコン": "チャット",
    "MAXページまでを表示しています": "1〜50ページまでを表示しています。これ以降はファイルをダウンロードしてご覧ください。",
    "KPIを選択してください" : "KPIを選択してください",
    "KPIが選択されていません" : "KPIが選択されていません",
    "投稿種別" : "投稿種別",
    "文字サイズ変更" : "文字サイズ変更",
    "端末設定が開きます。よろしいですか？" : "端末設定が開きます。よろしいですか？",
    "プロフィールを編集" : "プロフィールを編集",
    "自己紹介" : "自己紹介",
    "プロフィールテンプレートを使用する" : "プロフィールテンプレートを使用する",
    "プロフィールを登録する" : "テンプレートを使用してプロフィールを登録する",
    "プロフィールテンプレート" : "プロフィールテンプレートを使用します。よろしいですか？",
    "編集内容破棄タイトル": "編集中の内容が{{ name }}されていません。破棄しますか？",
    "編集内容破棄説明": "登録するには「取り消し」を押して「{{ name }}」ボタンを押してください。",
    "破棄": "破棄",
    "投稿の編集が完了しました" : "投稿の編集が完了しました。",
    "投稿しました" : "投稿しました。",
    "お客様のトライアル期間は終了しました" : "お客様のトライアル期間は終了しました。",
    "再度利用するにはもう一度トライアルをしてください" : "gamba!をご利用いただきありがとうございました。改めてご登録いただくことで再び無料トライアルが可能です。下部の「無料トライアルを始める」よりお申し込みください。",
    "【アプリ】再度利用するにはもう一度トライアルをしてください" : "gamba!をご利用いただきありがとうございました。改めてご登録いただくことで再び無料トライアルが可能です。",
    "ご契約を希望のお客様" : "ご契約を希望のお客様は",
    "こちら" : "こちら",
    "お申し込みください" : "よりお申し込みください。",
    "無料トライアルを始める" : "無料トライアルを始める",
    "全ての端末でログアウト" : "全ての端末でログアウトする" ,
    "入力内容不備" : "入力内容に不備があります。",
    "リアクション" : "リアクション",
    "下書き保存" : "下書き保存が完了しました。",
    "他n件のKPIをすべて表示": "他{{ n }}件のKPIをすべて表示",
    "対象ユーザーはこのグループに所属していません" : "対象ユーザーはこのグループに所属していません。" ,
    "通知設定" : "通知設定" ,
    "対応するアプリがない" : "対応するアプリがないため、ファイルを開くことができません。\n詳細はサポートサイトをご確認ください。",
    "ファイルを開けません" : "ファイルを開くことができません",
    "サポートサイトを開く" : "サポートサイトを開く",
    "ファイルはまだ処理中" : "このファイルはまだ処理中です。しばらくしてからもう一度お試しください。",
    "ファイルが読み込めない" : "このファイルは読み込めません。",
    "グループ所属" : "グループメンバーのみ表示",
    "グループ(未読)" : "グループ(未読)",
    "未読のみ表示" : "未読のみ表示",
    "未読グループがありません" : "未読グループがありません",
    "提出予定" : "提出予定",
    "月間サマリー編集モード": "{{ name }}　日報提出状況/編集",
    "提出予定登録説明" : "チェックを入れると提出予定が登録されます。",
    "提出予定登録" : "提出予定が登録されました。",
    "平日をすべて選択" : "平日をすべて選択",
    "リニューアル": "リニューアル中。\n今しばらく、お待ちください。",
    "リニューアル中": "リニューアル中。",
    "お待ちください": "今しばらく、お待ちください。",
    "レポート": "レポート",
    "日報の提出予定人数": "日報の提出予定人数",
    "週間レポート": "週間レポート",
    "月間レポート": "月間レポート",
    "週間レポートを出力する": "週間レポートを出力する",
    "月間レポートを出力する": "月間レポートを出力する",
    "週間レポート出力開始日": "週間レポート出力開始日",
    "月間レポート出力開始日": "月間レポート出力開始日",
    "レポート設定を更新しました": "レポート設定を更新しました",
    "日報の提出数がなし": "この期間に投稿がありませんでした。運用方法の検討はgamba!運営まで是非ご相談ください！",
    "日報の提出数が90%以上": "素晴らしい投稿率です！この調子で継続していきましょう！",
    "日報の提出数が増加": "前期間より好調です！投稿率90％を目指していきましょう！",
    "日報の提出数が減少": "前期間より投稿が減少しています。皆さんの投稿、お待ちしています！",
    "レスポンスなし": "レスポンスがないようです。まずは「いいね!」からポチッと！",
    "日毎集計": "日毎集計",
    "累計説明": "期間内の実績値を累計グラフで表示します。",
    "文字の大きさ": '文字の大きさ',
    "文字サイズ設定" : "文字サイズ設定",
    "文字サイズが保存されました": "文字サイズが保存されました。",
    "グループ内の投稿数": "・投稿数: {{posts}}件",
    "先月との投稿数の変化": "先月との投稿数の変化",
    "投稿なし": "投稿はありませんでした。gamba!に関するご質問やご相談がございましたら、お気軽にサポートまでお声がけください！",
    "投稿数50%未満": "チームの半分以上がまだ投稿していません。今日の出来事、ちょっとした気づきでもOKです！共有してみませんか？",
    "投稿数50-89%": "着実な投稿率です！あと一歩で90%達成です。チーム全員での情報共有を目指しましょう！",
    "投稿数90%以上": "すばらしい投稿率です！チーム全員で情報共有ができています！✨",
    "具体的な提出状況":"具体的な提出状況はこちらからご覧ください。",
    "大幅減少（-20%以上）": "最近投稿が少なめです。短い投稿でもOK！気軽に共有していきましょう！",
    "微減・現状維持（±10%）": "コンスタントな投稿、ありがとうございます。さらなる活性化を目指して、今日も一緒にgamba!していきましょう！",
    "増加（+10%以上）": "投稿数が増加中です！みなさんの積極的な共有に感謝です！この調子で90％達成を目指しましょう！",
    "反応なし": "みんなの投稿に反応してみましょう！まずは簡単な「いいね！」から！",
    "いいねのみ": "「いいね！」ありがとうございます！スタンプやコメントで更にコミュニケーションを広げてみませんか？",
    "多様な反応": "バランスの良い反応をありがとうございます！チームの絆が深まっています！",
    "reaction_compare": "投稿へのリアクション数の先月との比較",
    "反応減少（-20%以上）": "チームの交流が少し減っているようです。同僚の投稿にちょっとした一言を添えてみませんか？",
    "反応現状維持（±10%）": "安定した交流が続いていますね。新しい発見や気づきをコメントで共有してみましょう！",
    "反応増加（+10%以上）": "みなさんの活発な交流が増えています！このチームの雰囲気、素晴らしいですね！✨",
    "投稿率算出": "提出予定日を設定することで、より正確に日報の提出状況を把握できます。",
    "gamba!にご相談": "運用でお困りの際はいつでもgamba!にご相談ください！",
    "gamba!活用サポート予約窓口": "gamba!活用サポート予約窓口",
    "ご予約はこちら": "ご予約はこちら",
    "提出状況": "提出状況",
    "提出状況エクスポート": "提出状況エクスポート",
    "週の投稿": "{{week_number}}週の投稿",
    "こちらの使い方ガイド": "こちらの使い方ガイド",
    "report_collection": "集計期間： {{start_date, date}}〜{{end_date, date}}",
    "report_subject": "【{{month}}度 {{group_name}}グループ 投稿・リアクション レポート】",
    "reaction_subject": "・投稿へのリアクション：いいね {{likes}}件、コメント・スタンプ {{comments}}件",
    "パターン1": "{{posts}}件の投稿がありました。チームの活性度はいかがでしょうか？メンバーが気軽に投稿できる雰囲気づくりのため、管理者からコメントや「いいね」を送ってみましょう！",
    "パターン2": "{{posts}}件の共有がありました。投稿の内容や質に変化は感じられましたか？いつもと違う気づきがある投稿には、特にコメントで反応してみましょう！",
    "パターン3": "{{posts}}件の投稿がありました。普段あまり投稿しないメンバーの投稿にも目を向けてみましょう。その人ならではの視点に気づくかもしれません！",
    "パターン4": "{{posts}}件の活動共有がありました。チーム内で特に反響が大きかった投稿はありましたか？そのような投稿のポイントを他のメンバーにもシェアしてみましょう！",
    "パターン5": "{{posts}}件の投稿が集まりました。メンバー同士の情報共有が活発なトピックを見つけ、それを軸にした声がけをしてみるのはいかがでしょうか？",
    "パターン6": "{{posts}}件の共有がありました。特に有益だった気づきはありましたか？そういった投稿にはコメントで具体的に感想を伝えてみましょう！",
    "パターン7": "{{posts}}件の投稿がありました。チーム内でどんな話題が多かったでしょうか？注目の話題にコメントすることで、さらなる気づきの共有が生まれるかもしれません！",
    "パターン8": "{{posts}}件の共有がありました。メンバー同士のコメントのやり取りは活発でしたか？興味深い議論には、管理者の視点からもコメントを添えてみましょう！",
    "パターン9": "{{posts}}件の投稿がありました。朝一番の投稿や週初めの投稿への反応は、チームの1日、1週間のスタートを後押しします。積極的に声をかけてみましょう！",
    "パターン10": "{{posts}}件の活動報告が集まりました。新しい取り組みや改善の報告には、特に丁寧なフィードバックを心がけてみませんか？",
    "パターン11": "{{posts}}件の投稿がありました。困りごとや課題の共有には、チームの経験やナレッジを活かしたアドバイスで応援してみましょう！",
    "パターン12": "{{posts}}件の共有がありました。他部署との連携や協力の話題には、特に注目してみましょう。横のつながりを広げるきっかけになるかもしれません！",
    "パターン13": "{{posts}}件の投稿がありました。メンバーの成長や気づきが感じられる投稿はありましたか？そんな変化に気づいたら、具体的な言葉で認めてあげましょう！",
    "パターン14": "{{posts}}件の投稿が集まりました。チーム内で共有されている工夫やテクニックを見つけたら、ぜひ「参考になります！」とコメントしてみましょう！",
    "パターン15": "{{posts}}件の共有がありました。投稿の中から、チームの良い変化や成長を見つけ、みんなで共有してみませんか？",
    "パターン16": "{{posts}}件の活動共有を確認しました。投稿時間帯に傾向はありますか？チームの活動リズムを把握して、タイムリーな声がけを心がけてみましょう！",
    "パターン17": "{{posts}}件の投稿がありました。チームの雰囲気は感じ取れましたか？より活発なコミュニケーションのため、まずは管理者から率直な感想を伝えてみましょう！",
    "パターン18": "{{posts}}件の共有がありました。個人の小さな工夫や改善の報告にも目を向けてみましょう。それがチーム全体の財産になるかもしれません！",
    "レスポンスいいねのみ": "コメントやスタンプの活用で気持ちを伝えましょう！",
    "レスポンス量増加": "gamba!が全期間より盛り上がっているようです！",
    "レスポンス量減少": "レスポンスが減少傾向です。みんなで盛り上げていきましょう！",
    "Section preferences have been updated": "セクションを更新しました。",
    "Section": "一覧",
    "Section(unread)": "一覧(未読)",
    "Section name": "セクション名",
    "Division visibility": "Division visibility",
    "Group management": "グループ管理",
    "Download": "ダウンロード",
    "Move to trash": "ごみ箱に移動",
    "persons_count" : "{{ value }}人のメンバー",
    "Section settings": "セクション設定",
    "are_you_sure_you_want_to_move_the_division_to_trash": "このセクションがごみ箱に移動されます。\nセクションをごみ箱に移動してもよろしいですか？",
    "this_operation_will_affect_all_users_participating_in_the_division": "この操作はセクションに参加している全てのグループに影響します。",
    "complete_deletion_restoration_explanation": "セクションを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。",
    "export_all_groups": "すべてのグループを抽出",
    "既存グループを追加": "既存グループを追加",
    "Select_group": "グループを選択",
    "division_group_remove_consequence": "セクションから外しても過去の投稿は閲覧することができます。",
    "can_i_remove_group": "{{ name }}をグループから外してもよろしいですか?",
    "Return to linked section": "紐付いたセクションへ戻る",
    "Move to first level": "第一階層へ移動する",
    "選択できるグループがありません": "選択できるグループがありません",
    "セクションなし": "セクションなし",
    "AIレビュー":"AIレビュー(β版)",
    "この情報は役に立ちましたか":"この情報は役に立ちましたか？",
    "レポートお礼":"ご協力ありがとうございました！",
    "レビューする":"レビューする",
    "レビュー注意":"本アプリのAI技術は最善を尽くしておりますが、その応答には不正確さや誤解を招く可能性があります。",
    "注意URL":"https://www.getgamba.com/info/archives/52230/",
    "利用規約":"詳しくはこちら",
    "拡張機能":"拡張機能",
    "レビュー機能":"AIレビュー機能(β版)",
    "レビュー機能ON":"AIレビュー機能(β版)は、現在ONになっています。利用停止するには、アカウント管理者にお問い合わせください。(アカウント管理画面 ＞ 詳細設定 ＞ 拡張機能設定より変更頂けます。)",
    "レビュー機能OFF":"AIレビュー機能(β版)は、現在OFFになっています。利用するには、アカウント管理者にお問い合わせください。(アカウント管理画面 ＞ 詳細設定 ＞ 拡張機能設定より変更頂けます。)",
  },
  error: {
    "メールアドレスを入力してください": "メールアドレスを入力してください。",
    "パスワードを入力してください": "パスワードを入力してください。",
    "確認コードを入力してください": "確認コードを入力してください",
    "タイトルを入力してください": "タイトルを入力してください。",
    "テンプレート名を入力してください": "テンプレート名を入力してください。",
    "本文を入力してください": "本文を入力してください",
    "ユーザ名を入力してください": "ユーザ名を入力してください。",
    "グループ名を入力してください": "グループ名を入力してください。",
    "KPI名を入力してください": "KPI名を入力してください。",
    "単位を入力してください": "単位を入力してください。",
    "目標値を入力してください": "目標値を入力してください。",
    "実績値を入力してください": "実績値を入力してください。",
    "フィールド種別を選択してください": "入力種別を選択してください。",
    "フィールド名を入力してください": "項目名を入力してください。",
    "フィールドの選択肢を入力してください": "入力項目の選択肢を1つ以上指定してください。",
    "入力されていません": "入力されていません。",
    "チャットルーム名を入力してください": "チャットルーム名を入力してください",
    fetch_error: "サーバに接続できません。ネットワークエラーが発生しました。",
    s3upload: "動画ファイルのアップロードに失敗しました。時間をおいて再度お試しください。",
    invalid_flie: "選択された一部のファイルはサポートされておりません",
    "サーバ切断": "サーバの接続が切断されました。再接続中です。",
    "サーバ接続": "サーバの接続が復旧しました。",
    "google-calendar-events": "Googleカレンダーの予定表が取得できません。",
    "google-calendar-list": "Googleカレンダーの予定表が取得できません。",
    "google-drive-folders": "Googleドライブのフォルダリストを取得できません。",
    "google-drive-userinfo": "Googleドライブのユーザー情報を取得できません。",
    "google-refresh-token": "refresh tokenが取得できません。",
    "fetch-scheduled-settings": "定期実行設定を取り込めません。",
    "update-scheduled-settings": "定期実行設定が更新できません。",
    "upload-google-drive-file": "Googleドライブにファイルをアップロードできません。",
    "画像の読み込みに失敗しました": "存在しないか表示できないファイルです。",
    "暗号化PDF説明": "* 暗号化されたファイルの場合、右上の　「別ウィンドウで表示」のアイコンから開ける可能性があります。",
    "読み込みに失敗しました": "データの読み込みに失敗しました。",
    "ファイルが選択されていません": "ファイルが選択されていないか、写真もしくはカメラへのアクセスが許可されていません。",
    "フォトライブラリに保存できませんでした": "添付画像の保存ができませんでした。",
    "データの送信に失敗しました": "投稿の送信に失敗しました。インターネット接続を確認し、再度お試しください。",
    "インターネット接続に問題があります": "インターネット接続が確認できないため、投稿の一時保存ができません。",
    "インターネット再接続": "インターネット再接続しています。投稿の一時保存まだ完了しておりません。",
    "インターネット接続を確認してください": "インターネットに接続された状態で再度お試しください。",
    "別の投稿を編集中です": "現在別の投稿を編集中のため、開くことができません。",
    "unavailable": "現在、gamba!はご利用いただけません。しばらくお待ちください。",
    "URLが開けません": "URLが開けません",
    "コピーして下さい": "下記より、リンクをコピーしてブラウザからアクセスして下さい。\n\n",
    "ファイルサイズが制限を超えています": "ファイルサイズが制限を超えています。{{ max_file_size }}以上のファイルはアップロードできません。",
    "MSアカウント": "お使いのMicrosoftアカウントはカレンダーに対応しておりません"
  },
  url: {
    "gambaにログインできない": "https://support.getgamba.com/hc/ja/articles/900001776883",
    "無料体験リンク": "https://www.getgamba.com/v3/registration/new",
    "attachmentInfo": "https://support.getgamba.com/hc/ja/articles/900005545463",
  },
  timezone: {
    "UTC-12": "ベーカー島 ハウランド島",
    "UTC-11": "アメリカ領サモア ニウエ",
    "UTC-10": "ハワイ アリューシャン列島西部",
    "UTC-9": "アラスカ",
    "UTC-8": "アメリカ・カナダ・メキシコ(太平洋時間)",
    "UTC-7": "アメリカ・カナダ・メキシコ(山岳部時間)",
    "UTC-6": "アメリカ・カナダ・メキシコ(中部時間) 中央アメリカ",
    "UTC-5": "アメリカ・カナダ(東部時間) キューバ ペルー",
    "UTC-4": "カナダ(大西洋時間) 小アンティル諸島の大部分 ベネズエラ ブラジル(アマゾン時間) チリ",
    "UTC-3": "ブラジル(ブラジル時間) アルゼンチン グリーンランド",
    "UTC-2": "ブラジル(フェルナンド・デ・ノローニャ島)",
    "UTC-1": "アゾレス諸島 カーボベルデ",
    "UTC+0": "イギリス アイルランド ポルトガル アイスランド アフリゃ�ロッコ ガーナ等",
    "UTC+1": "中央ヨーロッパ時間(フランス ドイツ等) 西アフリカ時間(ナイジェリア コンゴ等)",
    "UTC+2": "東ヨーロッパ時間(フィンランド ウクライナ ギリシャ等) 中央アフリカ時間 南アフリカ",
    "UTC+3": "ロシア(モスクワ) ベラルーシ サウジアラビア 東アフリカ時間",
    "UTC+4": "ロシア(サマラ) アゼルバイジャン グルジア アラブ首長国連邦 モーリシャス",
    "UTC+5": "ロシア(エカテリンブルグ) パキスタン",
    "UTC+6": "ロシア(オムスク) カザフスタン バングラディシュ",
    "UTC+7": "ロシア(クラスノヤルスク) タイ ベトナム インドネシア西部時間",
    "UTC+8": "ロシア(イルクーツク) 中国 モンゴル マレーシア オーストラリア西部時間",
    "UTC+9": "日本 ロシア(ヤクーツク) 韓国 パラオ",
    "UTC+10": "ロシア(ウラジオストク) グアム オーストラリア東部時間",
    "UTC+11": "ロシア(マガダン) ソロモン諸島 ニューカレドニア",
    "UTC+12": "ロシア(カムチャッカ) ニュージーランド フィジー キリバス(ギルバート諸島)",
    "UTC+13": "トンガ キリバス(フェニックス諸島) サモア トケラウ",
    "UTC+14": "キリバス(ライン諸島)",
  },
  language: {
    "ja": "日本語",
    "en": "英語",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/message-ja.js